import {
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Select,
  TreeSelect,
} from "antd";
import { DataNode } from "antd/es/tree";
import { SelectOps } from "../selectComponent/model/SelectOpsModel";
import { FilterAttributes } from "./model/FilterComponentsModel";

export const FilterComponent = <T extends FilterAttributes[]>(
  data: T,
  form?: FormInstance
) => {
  return (
    <>
      {data?.map((item, index) => {
        return (
          <Col span={24} lg={item?.colLg} key={index}>
            <div className="truncate">{item?.labelName}</div>
            {item?.filterType === "select-multiple" ? (
              <Form.Item
                name={item?.filterName}
                initialValue={item?.defaultValue}
              >
                <Select
                  mode="multiple"
                  disabled={item?.disable ?? false}
                  defaultValue={item?.defaultValue as string[]}
                  showSearch
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  filterOption={(input, option) => {
                    if (typeof option?.label === "string") {
                      return option.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                  options={item?.options as SelectOps[]}
                  placeholder={item?.placeholder}
                  maxTagCount={"responsive"}
                  onChange={(selected) => {
                    const ALL_VALUE = "";
                    let newSelected: string[];

                    if (
                      !selected.includes(ALL_VALUE) ||
                      (selected.includes(ALL_VALUE) &&
                        selected[0] === ALL_VALUE)
                    ) {
                      if (selected.length === 0) {
                        newSelected = [ALL_VALUE];
                      } else
                        newSelected = selected.filter(
                          (val) => val !== ALL_VALUE
                        );
                    } else {
                      newSelected = [ALL_VALUE];
                    }
                    form &&
                      form.setFieldsValue({ [item.filterName]: newSelected });
                    if (item?.onChange) {
                      item.onChange(newSelected);
                    }
                  }}
                />
              </Form.Item>
            ) : item?.filterType === "input" ? (
              <Form.Item name={item?.filterName}>
                <Input
                  style={{ width: "100%" }}
                  disabled={item?.disable ?? false}
                  placeholder={item?.placeholder}
                  prefix={item?.prefixIcon}
                  maxLength={!!item?.maxLength ? item?.maxLength : undefined}
                />
              </Form.Item>
            ) : item?.filterType === "select" ? (
              <Form.Item name={item?.filterName}>
                <Select
                  defaultValue={item?.defaultValue}
                  showSearch
                  disabled={item?.disable ?? false}
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  filterOption={(input, options) => {
                    if (typeof options?.label === "string") {
                      return options?.label
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }
                    return false;
                  }}
                  options={item?.options as SelectOps[]}
                  onChange={(value) =>
                    !!item?.onChange ? item?.onChange(value) : null
                  }
                />
              </Form.Item>
            ) : item?.filterType === "range-date" ? (
              <Form.Item name={item?.filterName}>
                <DatePicker.RangePicker
                  style={{ width: "100%" }}
                  allowClear={false}
                  disabled={item?.disable ?? false}
                  defaultValue={item?.defaultRangeDay}
                  onChange={(value) =>
                    !!item?.onChange ? item?.onChange(value) : null
                  }
                  format={"DD/MM/YYYY"}
                />
              </Form.Item>
            ) : (
              <Form.Item name={item?.filterName}>
                <TreeSelect
                  style={{ width: "100%" }}
                  disabled={item?.disable ?? false}
                  dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                  }}
                  defaultValue={item?.defaultValue}
                  showSearch
                  filterTreeNode={(inputValue, treeNode) => {
                    if (typeof treeNode.title === "string") {
                      return treeNode.title
                        .toLowerCase()
                        .includes(inputValue.toLowerCase());
                    }
                    return false;
                  }}
                  treeData={item?.options as DataNode[]}
                  placeholder={item?.placeholder}
                  treeDefaultExpandAll
                />
              </Form.Item>
            )}
          </Col>
        );
      })}
    </>
  );
};
